export enum InvoiceEditStatusType {
  Open,
  Paid,
  Closed,
  Overdue
}
